<template>
  <div class="container">
    <GenericButton
      v-if="showSettings"
      class="settings-icon-img"
      svg="close"
      title="Hide Load Menu"
      @click="showSettings = !showSettings"
    />
    <GenericButton
      v-if="!showSettings"
      class="settings-icon-img"
      svg="settings"
      title="Show Load Menu"
      @click="showSettings = !showSettings"
    />
    <div
      class="settings-container"
      v-if="showSettings"
    >
      <div class="settings-title">
        Load Level
      </div>
      <div class="static-levels-container">
        <GenericButton
          v-for="(build, index) in buildData.static"
          :key="index"
          :text="buildData.static[index].info.currentLevel.toString()"
          font-size="14px"
          width="30%"
          height="24px"
          :title="'Click to load at level ' + buildData.static[index].info.currentLevel"
          @click.stop="loadBuild('static', index)"
        />
      </div>
      <div class="dynamic-levels-container">
        <GenericButton
          v-for="(build, index) in buildData.dynamic"
          :key="index"
          :text="buildData.dynamic[index].info.currentLevel.toString()"
          font-size="14px"
          width="30%"
          height="24px"
          :title="'Click to load at level ' + buildData.dynamic[index].info.currentLevel"
          @click.stop="loadBuild('dynamic', index)"
        />
      </div>
    </div>
    <div
      class="main-container"
      v-if="!showSettings"
    >
      <div class="column-row">
        <div
          class="level-up-skillpoints-container"
        >
          <div class="level-up-skillpoints-name">
            SKILL POINTS
          </div>
          <div class="level-up-skillpoints-value">
            {{ buildData.skillPoints }}
          </div>
        </div>

        <div
          class="level-up-level-container"
        >
          <div class="level-up-level-name">
            LEVEL
          </div>
          <div class="level-up-level-value">
            {{ buildData.currentLevel }}
          </div>
        </div>
      </div>
      <GenericButton
        @click="levelUp()"
        text="LEVEL UP"
        width="95%"
        font-size="18px"
        style="margin: auto;"
      />
      <GenericTabs
        :tabs="tabs"
        variant="group"
        @activeTab="handleActiveTab"
      />
    </div>
  </div>
</template>
<script>
import { ref, watch, defineComponent, computed } from "vue";
import { useStore } from "vuex";
import LS from '@/utils/localStorageHandler'
import GenericButton from "../shared/GenericButton.vue";
import GenericTabs from "../shared/GenericTabs.vue";
export default defineComponent({
    name: "LevelUp",
    setup() {
        const store = useStore();
        const multiplier = ref(1);
        const showSettings = ref(false);
        const showModifiers = () => {
            return store.state.build.info.currentLevel > 23;
        };
        const checkForAvailablePerk = () => {
            return store.state.build.info.currentPerk.available;
        };

        const buildData = computed(() => {
          const data = LS.getCurrentBuild(store.state.system.storage);
            const trimStatic = data.static.length > 3 ? [...data.static].slice(0, 3) : data.static;
            return {
                static: trimStatic,
                dynamic: data.dynamic,
                currentLevel: store.state.build.info.currentLevel,
                skillPoints: store.state.build.info.availableSkillPoints,
            };
        });

        const loadBuild = (type, slot) => {
            const data = LS.getCurrentBuild(store.state.system.storage);
            if (data[type][slot]) {
                store.dispatch('handleIncomingCommand', {
                    command: 'loadBuild',
                    data: data[type][slot]
                });
                showSettings.value = false;
            }
        };

        const levelUp = () => {
            store.dispatch('handleIncomingCommand', {
                command: 'levelUp',
                data: { multiplier: multiplier.value }
            });
        };

        const isLastPerkAvailable = () => {
          return showModifiers() && checkForAvailablePerk();
        }

        const handleActiveTab = (tab) => {
          multiplier.value = tab.value;
        }

        watch(() => store.state.build.info.currentLevel, (to) => {
            if (to === 24 || isLastPerkAvailable()) {
                multiplier.value = 1;
            }
        });

        const tabs = computed(() => {
          return [
            {
              name: 'x1',
              value: 1,
              selected: multiplier.value === 1,
              warning: '',
            },
            {
              name: 'x5',
              value: 5,
              selected: multiplier.value === 5,
              warning: checkForAvailablePerk(),
              disabled: isLastPerkAvailable(),
              hidden: !showModifiers(),
            },
            {
              name: 'x10',
              value: 10,
              selected: multiplier.value === 10,
              warning: checkForAvailablePerk(),
              disabled: isLastPerkAvailable(),
              hidden: !showModifiers(),
            },
            {
              name: 'x100',
              value: 100,
              selected: multiplier.value === 100,
              warning: checkForAvailablePerk(),
              disabled: isLastPerkAvailable(),
              hidden: !showModifiers(),
            },
            {
              name: checkForAvailablePerk() ? 'CHOOSE PERK!' : 'TO NEXT PERK',
              value: -1,
              selected: multiplier.value === -1,
              warning: checkForAvailablePerk(),
              hidden: showModifiers(),
            },
          ]
        })
        return {
            state: store.state,
            multiplier,
            showModifiers,
            checkForAvailablePerk,
            levelUp,
            showSettings,
            loadBuild,
            handleActiveTab,
            tabs,
            buildData,
        };
    },
    components: { GenericButton, GenericTabs }
});
</script>
<style scoped>
.container {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.column-row {
  display: flex;
}
.main-container,
.settings-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 100%;
  height: 100%;
  /* row-gap: 4px; */
}
.level-up-skillpoints-container,
.level-up-level-container {
  display: flex;
  flex-direction: column;
  position: relative;
  color: white;
  margin: auto;
  margin-left: 2px;
  width: 46%;
  font-size: 12px;
  font-family: var(--font-family-gothic);
}
.settings-icon-img {
  z-index: 1;
  position: absolute;
  top: -3px;
  right: 0px;
  width: 20px;
  height: 20px;
  fill: var(--text-green);
}
.settings-icon-img:hover {
  cursor: pointer;
  fill: #d4f7c8;
}

.level-up-skillpoints-name,
.level-up-level-name {
  width: 100%;
  z-index: 0;
  color: var(--text-green);
}
.level-up-skillpoints-value,
.level-up-level-value {
  width: 100%;
  font-size: 22px;
  height: 24px;
  margin-bottom: 3px;
  -webkit-text-stroke: var(--text-stroke-black);
}
.settings-title {
  margin-bottom: 6px;
}
.static-levels-container,
.dynamic-levels-container {
  display: flex;
  justify-content: space-around;
  margin: 3px;
}
</style>